export const AuthProviderEnum = {
  email: "password",
  facebook: "facebook.com",
  google: "google.com"
};


// WEBPACK FOOTER //
// ./src/app/modules/auth/domain/enums/AuthProvidersEnum.ts